import { Vector2 } from 'three'

export default {
  uniforms: {
    tPrev: { type: 't', value: 0, texture: null }, // The base scene buffer
    tDiffuse: { type: 't', value: 0, texture: null }, // The base scene buffer
    tGlow: { type: 't', value: 1, texture: null }, // The glow scene buffer
    tBloom: { type: 't', value: 1, texture: null }, // The glow scene buffer
    bloomAmount: { value: 0 }, // The glow scene buffer
    distortAmount: { value: 0 }, // The glow scene buffer
    fadeAmount: { value: 0 },
    invertAmount: { value: 0 }, // The glow scene buffer
    resolution: { value: new Vector2(window.innerWidth, window.innerHeight) }, // The glow scene buffer
    time: { value: 0 }, // The glow scene buffer
    fxAmount: { value: 0 }
  },

  vertexShader: `
    varying vec2 vUv;
    //varying vec2 screenPosition;

    void main() {
      
      vUv = vec2( uv.x, uv.y );
      gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

    }
  `,

  fragmentShader: `
    uniform sampler2D tDiffuse;
    uniform sampler2D tBloom;
    uniform float fxAmount;
    uniform float bloomAmount;
    uniform float fadeAmount;
    uniform float time;
    uniform vec2 resolution;
    varying vec2 vUv;

    void main() {
      
      vec4 texel = texture2D( tDiffuse, vUv);
      vec4 bloomFx = texture2D( tBloom, vUv );
      
      gl_FragColor = LinearTosRGB(texel + bloomFx*bloomAmount);
      gl_FragColor = mix(gl_FragColor,vec4(0.0,0.0,0.0,1.0), fadeAmount);
      
    }
  `
}
